import { apiRequest } from '@/api/apiClient/base';
import type { IndexStatus } from '@/api/types';

/**
 * Whether the registrar is currently indexing the repository and whether it has
 * read the repo at least once. Public: every visitor can read it, so the Home
 * page can show live index progress while the first read runs instead of a
 * dead-end "not ready" error.
 */
export function getIndexStatus(): Promise<IndexStatus> {
  return apiRequest<IndexStatus>('/api/index-status');
}
